module.exports = __webpack_public_path__ + "static/media/medium.4f2ced08.png";